{
  "de": {
    "profile": {
      "actions": {
        "changeEmail": "E-Mail-Adresse ändern",
        "changeEmailAddress": "E-Mail-Adresse ändern",
        "delete": "Löschen",
        "installApp": "App installieren 🚀",
        "launchApp": "App starten",
        "save": "Speichern",
        "showQRCode": "QR-Code anzeigen"
      },
      "attributes": {
        "decimal_separator": "Dezimaltrennzeichen der Währung",
        "email_address": "E-Mail",
        "email_address_new": "Neue E-Mail-Adresse",
        "email_address_old": "Alte E-Mail-Adresse"
      },
      "labels": {
        "addToHomeScreen": "Zum Startbildschirm hinzufügen",
        "allowAccess": "Ziggu Zugriff auf Ihr Konto geben",
        "allowImpersonation": "Ziggu-Zugriff erlauben",
        "allowImpersonationSubtext": "Wir benötigen unter Umständen vorübergehenden Zugriff auf Ihr Konto, um ein von Ihnen gemeldetes Support-Problem zu diagnostizieren und zu lösen. Unser Zugriff läuft automatisch nach 7 Tagen ab.",
        "allowRecording": "Sitzungsaufzeichnung erlauben",
        "allowRecordingSubtext": "Die Aufzeichnung Ihrer Sitzung in Ziggu kann uns helfen, die Ursache eines von Ihnen gemeldeten Problems zu finden. Die Aufzeichnung endet automatisch nach 60 Minuten oder sobald Sie diese Einstellung deaktivieren.",
        "and_x_other": "und 1 weitere | und {other_count} weitere",
        "bulk_invite_help": "Wir werden die ausgewählten Kontakte zur Plattform einladen. Dies kann einige Minuten dauern.",
        "changeEmailAddress": "E-Mail-Adresse für {profile_name} ändern",
        "checkYourInbox": "Wir haben eine E-Mail zur Bestätigung an {email_address} gesendet",
        "confirmEmailUpdate": "Die E-Mail enthält einen Link, um den Aktualisierungsprozess abzuschließen. Kontaktieren Sie uns, falls Probleme auftreten.",
        "confirmPasswordReset": "Eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts wurde gesendet. Bitte prüfen Sie Ihren Posteingang. Kontaktieren Sie uns, falls Probleme auftreten.",
        "currency": {
          "comma": "Dezimalkomma: 200.450,99",
          "point": "Dezimalpunkt: 200,450.99"
        },
        "emailAddressNewConfirm": "Neue E-Mail-Adresse bestätigen",
        "emailNotificationsInterval": "E-Mail-Häufigkeit für neue Benachrichtigungen",
        "emailNotificationsIntervalSubtext": "Hier können Sie festlegen, wie oft die Plattform prüfen soll, ob es Neuigkeiten für Sie gibt, und Ihnen eine E-Mail darüber senden soll.",
        "explainerSendEmail": "Eine neue Einladungs-E-Mail wird an {name} gesendet",
        "explainerUpdateEmailActive": "{name} ist bereits aktiv auf der Plattform. Eine E-Mail mit einem Link zur Bestätigung der E-Mail-Adressänderung wird an die neue E-Mail-Adresse gesendet.",
        "explainerUpdateEmailInvited": "{name} wurde bereits eingeladen. Eine neue Einladung wird an die neue E-Mail-Adresse gesendet. Vorherige Einladungen werden ungültig.",
        "followDevicePrompts": "Folgen Sie den Anweisungen Ihres Geräts, um die App zum Startbildschirm hinzuzufügen",
        "impersonateProfile": "Identität von {profile_name} übernehmen",
        "important": "Wichtig",
        "importantContent": "Stellen Sie sicher, dass Sie auf der Plattform auf Ihrem mobilen Gerät über den Webbrowser angemeldet sind.",
        "installMobileApp": "Mobile App installieren",
        "logInMobileDevice": "Auf Ihrem mobilen Gerät anmelden",
        "maintainerCannotImpersonatePartner": "Nur Teammitglieder mit der Rolle „Inhaber“ können die Identität von Partnern übernehmen.",
        "maintainerCannotUpdateEmailAddress": "Nur Teammitglieder mit der Rolle „Inhaber“ können die E-Mail-Adresse aktualisieren",
        "multipleProfiles": "Dieser Nutzer hat mehrere Ziggu-Profile. Nur der Nutzer kann die E-Mail-Adresse ändern.",
        "mustBeLoggedInBeforeQR": "Sie müssen auf Ihrem mobilen Gerät angemeldet sein, bevor Sie den QR-Code scannen",
        "noEmailAddressAdded": "Keine E-Mail-Adresse hinzugefügt",
        "onceLoggedInScan": "Sobald Sie angemeldet sind, scannen Sie den QR-Code, um die App auf Ihrem Gerät zu installieren",
        "openMobileBrowser": "Öffnen Sie Ihren mobilen Browser und besuchen Sie",
        "public_api_access": "Öffentliches API-Zugriffstoken",
        "redirectAutomatically": "Sie werden in {seconds} Sekunden automatisch weitergeleitet",
        "requestPasswordReset": "Passwort zurücksetzen",
        "scanQRCode": "QR-Code scannen",
        "toLogInCredentials": "um sich mit Ihren Zugangsdaten anzumelden",
        "updateEmailFailed": "Ihre E-Mail-Adresse konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.",
        "updateEmailSuccessful": "Ihre E-Mail-Adresse wurde erfolgreich aktualisiert",
        "updateFailed": "Aktualisierung fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie uns."
      },
      "notifications": {
        "avatarChangedSuccessfully": "Der Avatar wurde aktualisiert. Es kann bis zu einer Stunde dauern, bis die Änderungen sichtbar sind."
      },
      "toasts": {
        "bulk_invite": "Wir haben begonnen, die ausgewählten Kontakte zur Plattform einzuladen",
        "emailResendSuccessfully": "E-Mail erfolgreich erneut gesendet"
      },
      "validation": {
        "emailAddressBounce": {
          "hard_bounce": "Die E-Mail-Adresse existiert entweder nicht oder nicht mehr. Bitte ändern Sie die E-Mail-Adresse.",
          "illegal_address": "Ungültige E-Mail-Adresse: Die von Ihnen angegebene E-Mail-Adresse ist möglicherweise nicht korrekt eingerichtet. Bitte stellen Sie sicher, dass die E-Mail-Adresse korrekt formatiert ist und keine ungültigen Zeichen enthält.",
          "isp_block": "ISP-Sperre: Eine Sperre bedeutet in der Regel, dass unsere IP-Adresse oder unser Server vom empfangenden Mailserver abgelehnt wurde.",
          "soft_bounce": "Die Person ist außer Haus, oder das Postfach ist voll und nimmt keine E-Mails mehr an.",
          "spam_complaint": "Die Person hat in ihrem E-Mail-Programm auf „Als Spam markieren“ geklickt, diese E-Mail-Adresse wurde deaktiviert. Falls sich der Empfänger bei Ihnen meldet und wieder E-Mails erhalten möchte, kontaktieren Sie uns.",
          "spam_notification": "E-Mails wurden vom Mailserver abgelehnt. Dies kann an strengen Unternehmensrichtlinien des empfangenden Mailservers liegen oder an einer unglücklichen Wortwahl in Ihrer E-Mail, die von Spamfiltern erkannt wird."
        },
        "emailAddressBounced": "Fehler bei der E-Mail-Adresse",
        "emailDoesntMatch": "E-Mail-Adresse stimmt nicht überein",
        "emailTaken": "Diese E-Mail-Adresse wird bereits verwendet. Falls Sie diese Änderung trotzdem vornehmen möchten, kontaktieren Sie uns bitte über den Chat.",
        "mustBeEmailAddress": "Gültige E-Mail-Adresse erforderlich",
        "requireEmailAddress": "E-Mail-Adresse erforderlich",
        "tooManyRequests": "Nur eine E-Mail-Adressänderung alle 5 Minuten erlaubt. Versuchen Sie es später erneut."
      }
    }
  }
}
